var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_596_15)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.696 20.7373V11.7466L21.3413 16.2573L12.696 20.7373ZM31.68 10.188C31.68 10.188 31.3667 7.98265 30.408 7.01198C29.1907 5.73731 27.8267 5.73198 27.2013 5.65731C22.724 5.33331 16.0067 5.33331 16.0067 5.33331H15.9933C15.9933 5.33331 9.276 5.33331 4.79867 5.65731C4.172 5.73065 2.80933 5.73731 1.59067 7.01198C0.632 7.98265 0.32 10.188 0.32 10.188C0.32 10.188 0 12.7786 0 15.3666V17.796C0 20.3853 0.32 22.9746 0.32 22.9746C0.32 22.9746 0.632 25.1786 1.59067 26.1506C2.80933 27.4253 4.408 27.3853 5.12 27.5186C7.68 27.764 16 27.84 16 27.84C16 27.84 22.724 27.8306 27.2013 27.5066C27.828 27.432 29.1907 27.4253 30.408 26.1506C31.368 25.1786 31.68 22.9746 31.68 22.9746C31.68 22.9746 32 20.3853 32 17.7946V15.368C32 12.7786 31.68 10.188 31.68 10.188Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_596_15"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.a56311b1105a2cd97310b4c3ca9ab9f9.svg";
export { ForwardRef as ReactComponent };